import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { hasActivePlan } from '../utils/plan';

const RequirePlan: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    let mounted = true;
    hasActivePlan().then((result) => {
      if (mounted) setAllowed(result);
    });
    return () => { mounted = false; };
  }, []);

  if (allowed === null) return <div>Loading...</div>;
  if (!allowed) return <Navigate to="/plans" replace />;
  return <>{children}</>;
};

export default RequirePlan; 